import React from 'react';
import { useDispatch } from 'react-redux';

import { hideModal, showModal } from 'legacy/actions/modalActions';

const EventQuestions = ({ requiredInfo, event, refetchTicketInfoRequired }) => {
  const dispatch = useDispatch();

  if (
    !requiredInfo?.googleForms?.required &&
    !requiredInfo?.ticketNotes?.required
  ) {
    return null;
  }

  const onClick = () => {
    const modalId = requiredInfo?.ticketNotes?.required
      ? 'TICKET_NOTES'
      : 'FILL_FORM';

    const modalProps = {
      event,
      shouldPromptBeforeClose: false,
      guestQuestions: undefined,
      onClose: () => {
        dispatch(hideModal());
      },
      onSuccess: () => {
        refetchTicketInfoRequired();
        dispatch(hideModal());
      }
    };

    if (modalId === 'TICKET_NOTES') {
      modalProps.shouldPromptBeforeClose = true;
      modalProps.guestQuestions = requiredInfo.ticketNotes.guestQuestions;
    }

    dispatch(showModal(modalId, modalProps));
  };

  return (
    <div className="mt-8 p-6 bg-secondary-500 border-1 border-secondary-500 bg-opacity-25 rounded-2xl">
      <p className="font-normal text-sm text-gray-500 leading-relaxed">
        This event requires you to fill out some additional information.
      </p>

      <div
        className="mt-4 text-primary-500 text-center cursor-pointer"
        onClick={onClick}
      >
        Fill out Requested Info
      </div>
    </div>
  );
};

export default EventQuestions;
